import React from 'react';
import { List, Image } from 'semantic-ui-react';

export default function TopPoster(arr, i) {
	return (
		<List.Item key={i}>
			<Image circular src={arr[1].avatar} />
			<List.Content>
				<List.Header as='a'>{arr[0]}</List.Header>
				<List.Description>{arr[1].count} posts</List.Description>
			</List.Content>
		</List.Item>
	);
}



// WEBPACK FOOTER //
// ./src/components/MetaPanel/TopPoster.js